import React from 'react';
import Icon from '../AppIcon';

const QuoteStatusIndicator = ({ 
  status, 
  size = 'default', 
  showIcon = true, 
  showTooltip = true,
  className = '' 
}) => {
  const statusConfig = {
    draft: {
      label: 'Draft',
      color: 'bg-muted text-muted-foreground',
      icon: 'FileEdit',
      tooltip: 'Quote is being prepared and can be edited'
    },
    pending: {
      label: 'Pending Review',
      color: 'bg-warning text-warning-foreground',
      icon: 'Clock',
      tooltip: 'Quote sent to client and awaiting review'
    },
    approved: {
      label: 'Approved',
      color: 'bg-success text-success-foreground',
      icon: 'CheckCircle',
      tooltip: 'Quote approved by client and ready for project start'
    },
    rejected: {
      label: 'Rejected',
      color: 'bg-error text-error-foreground',
      icon: 'XCircle',
      tooltip: 'Quote rejected by client - revisions may be needed'
    },
    expired: {
      label: 'Expired',
      color: 'bg-secondary text-secondary-foreground',
      icon: 'AlertTriangle',
      tooltip: 'Quote has passed expiration date and needs renewal'
    },
    completed: {
      label: 'Completed',
      color: 'bg-accent text-accent-foreground',
      icon: 'CheckCircle2',
      tooltip: 'Project completed successfully'
    }
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    default: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 12,
    default: 14,
    lg: 16
  };

  const config = statusConfig?.[status] || statusConfig?.draft;
  const sizeClass = sizeClasses?.[size];
  const iconSize = iconSizes?.[size];

  const badge = (
    <span 
      className={`inline-flex items-center space-x-1.5 font-medium rounded-full transition-smooth ${config?.color} ${sizeClass} ${className}`}
      title={showTooltip ? config?.tooltip : undefined}
    >
      {showIcon && <Icon name={config?.icon} size={iconSize} />}
      <span>{config?.label}</span>
    </span>
  );

  return badge;
};

export default QuoteStatusIndicator;